
const CHANGE_DATE_FORMAT = "calendar:CHANGE_DATE_FORMAT";
const CHANGE_DATE_FORMAT_INCLUDES_DAY_NAME = "calendar:CHANGE_DATE_FORMAT_INCLUDES_DAY_NAME";
const CHANGE_TIME_FORMAT = "calendar:CHANGE_TIME_FORMAT";
const CHANGE_DATE_ORDER = "calendar:CHANGE_DATE_ORDER";

export const actionTypes = {
  CHANGE_DATE_FORMAT,
  CHANGE_DATE_FORMAT_INCLUDES_DAY_NAME,
  CHANGE_TIME_FORMAT,
  CHANGE_DATE_ORDER
};


const changeDateFormat = format => {
  return {
    type: CHANGE_DATE_FORMAT,
    format
  };
};

const changeDateFormatIncludesDayName = includesDay => {
  return {
    type: CHANGE_DATE_FORMAT_INCLUDES_DAY_NAME,
    includesDay
  };
};

const changeTimeFormat = format => {
  return {
    type: CHANGE_TIME_FORMAT,
    format
  };
};

const changeDateOrder = order => {
  return {
    type: CHANGE_DATE_ORDER,
    order
  };
};

export default {
  changeDateFormat,
  changeTimeFormat,
  changeDateOrder,
  changeDateFormatIncludesDayName
};
